import React from 'react';
import H2 from './H2';
import H3 from './H3';
import ReadMoreReadLess from './ReadMoreReadLess';

function ShowMeMore({ title, text, className, titleStyle }) {
  return (
    <div className={`${className} text-dark-800`}>
      { titleStyle
        ? <H3 text={title} className="mt-8" />
        : <H2 text={title} className="lg:mt-[50px] mt-8" />
      }
      
      <div className="mt-6 font-sans text-base xl:text-lg">
        {text && <ReadMoreReadLess>{text}</ReadMoreReadLess>}
      </div>
    </div>
  );
}

export default ShowMeMore;
